import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { GET_CURRENT_CAMPAIGN_RESET } from '../redux/types'
import { get_current_campaign_user } from '../redux/actions/campaignActions'
import Slider from 'react-slick'

const CampaignSlider = () => {
	const dispatch = useDispatch()

	const settings = {
		dots: true,
		infinite: true,
		speed: 1500,
		slidesToShow: 1,
		arrows: false,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 9000,
		pauseOnHover: false,
	}

	const getCurrentCampaign = useSelector((state) => state.getCurrentCampaign)
	const { currentCampaign } = getCurrentCampaign

	useEffect(() => {
		dispatch(get_current_campaign_user())

		return () => {
			dispatch({ type: GET_CURRENT_CAMPAIGN_RESET })
		}
	}, [dispatch])

	return (
		<div>
			<Slider {...settings}>
				{currentCampaign &&
					currentCampaign.map((e) => (
						<div>
							<div
								className='container about_jumbo jumbo_section'
								style={{ background: `url(${e.banner})` }}
								key={e._id}
							>
								<div
									className='d-flex '
									style={{
										alignItems: 'center',
										height: '50vh',
										color: '#fff',
										position: 'relative',
										zIndex: '1',
									}}
								>
									<div className='pl-5'>
										<h1>
											<strong> {e.name} </strong>
										</h1>
										<p> Status: {e.status} </p>
										<h3> {e.intro} </h3>
										<h5 className='mb-4'>{e.details.substring(0, '80')}</h5>
										<Link
											to='/user/dashboard/submissions/create'
											className='homepage_btn'
										>
											Submit Script
										</Link>
									</div>
								</div>
							</div>
						</div>
					))}
			</Slider>
		</div>
	)
}

export default CampaignSlider
